export enum JobDurationTimelineEnum {
  "Less_Than_One_Month" = 1,
  "One_To_Three_Months" = 2,
  "Three_To_Six_Months" = 3,
  "More_Than_Six_Months" = 4,
}
